import StantMultiselect from "../../utils/stant_multiselect.coffee"

$(document).on 'turbolinks:load', ->
  new StantMultiselect('companies-multiselect').add_listener()
